// Podcast platform information
// Set any URL to an empty string to hide it from the website

// RSS feed URL from Buzzsprout
export const rssFeedUrl = "https://feeds.buzzsprout.com/2501774.rss";

// Support links
export const buyMeCoffeeUrl = "https://buymeacoffee.com/containerizedconversation";
export const patreonUrl = ""; // Add your Patreon URL if you have one

// Podcast platform URLs - set to empty string to hide
export const spotifyUrl = "https://open.spotify.com/show/1qamhOq8pb8dyp6W3OFJrF"; // Replace with your actual Spotify URL
export const applePodcastsUrl = "https://podcasts.apple.com/us/podcast/containerized-conversations/id1814008212"; // Replace with your actual Apple Podcasts URL
export const googlePodcastsUrl = ""; // Replace with your actual Google Podcasts URL
export const youtubeUrl = "https://www.youtube.com/@containerizedconversations"; // Replace with your actual YouTube URL
export const amazonMusicUrl = ""; // Replace with your Amazon Music URL if available
export const castboxUrl = ""; // Replace with your Castbox URL if available
export const pocketCastsUrl = ""; // Replace with your Pocket Casts URL if available
export const overcastUrl = ""; // Replace with your Overcast URL if available
export const stitcherUrl = ""; // Replace with your Stitcher URL if available
export const iHeartRadioUrl = "https://iheart.com/podcast/275178730/"; // Replace with your iHeartRadio URL if available
export const tuneinUrl = ""; // Replace with your TuneIn URL if available
export const playerFmUrl = ""; // Replace with your Player.fm URL if available